import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { TipoSensor } from './tipoSensor';

import myGlobals = require('../config');

@Injectable()
export class TipoSensorService {

  private tipoSensorUrl = myGlobals.default.BASE_URL + '/tipoSensor/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los tipoSensors habilitados para el usuario
  getTipoSensores() {
    return this.http.get(this.tipoSensorUrl)
      .map((response) => response.json());
  }

  //Obtener un tipoSensor
  getTipoSensor(_id: string): Observable<TipoSensor> {
    return this.http.get(this.tipoSensorUrl + _id)
      .map((response) => response.json());
  }

  //Obtener tipoSensors by sucursal
  getTipoSensoresBySucursal(_id: string) {
    return this.http.get(this.tipoSensorUrl + "sucursal/" + _id)
      .map((response) => response.json());
  }

  save(tipoSensor: TipoSensor): Observable<TipoSensor> {
    if (tipoSensor._id) {
      return this.put(tipoSensor);
    }
    //Seteo estado activo
    tipoSensor.estado = true;
    return this.post(tipoSensor);
  }

  //Desactivar tipoSensor
  delete(tipoSensor: TipoSensor) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.tipoSensorUrl}/${tipoSensor._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nuevo tipoSensor
  private post(tipoSensor: TipoSensor): Observable<TipoSensor> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    console.log(tipoSensor);
    console.log(JSON.stringify(tipoSensor));
    var tipoSensorStr = JSON.stringify(tipoSensor);
    return this.http
      .post(this.tipoSensorUrl, tipoSensorStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar tipoSensor
  private put(tipoSensor: TipoSensor) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.tipoSensorUrl}/${tipoSensor._id}`;

    return this.http
      .put(url, JSON.stringify(tipoSensor), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoSensor/tipoSensor.service.ts